var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8239 1.58374L8.69376 6.76734C8.28006 7.06731 7.72132 7.06731 7.30762 6.76734L0.193973 1.59363C0.179139 1.60022 0.184084 1.59693 0.170898 1.60517V8.52597V9.43413V10.9999H1.73669H14.263H15.8288V9.43413V8.52597V1.58539C15.8255 1.58374 15.8272 1.58539 15.8239 1.58374Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3659 0H0.673828L0.990283 0.238989L7.30785 4.83253C7.72154 5.1325 8.28029 5.1325 8.69398 4.83253L14.9341 0.295028L15.3659 0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailIcon);
export default __webpack_public_path__ + "static/media/email-icon.37d34ae210c0f942113761530aada47a.svg";
export { ForwardRef as ReactComponent };